import { Text, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { i18n } from '@investigator/shared/localization';

const { noDataFound } = i18n.pages.entityDetails;

export interface NoDataSectionProps {
  header: ReactNode;
}

export const NoDataSection = ({ header }: NoDataSectionProps): JSX.Element => (
  <VStack alignItems="start">
    {header}
    <Text color="gray.400">{noDataFound}</Text>
  </VStack>
);
